import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {updateSpotToRemove} from '../../actions/checkout';

class ReservedSpotRadioButton extends Component {

  render() {
    const {spotName, spotToUnreserve, isLocked} = this.props;
    const checked = (!isLocked && spotName === spotToUnreserve) ? "checked" : "";

    return (
      <div className="radio">
        <label>
          <input
            type="radio"
            name="optionsRadios"
            id="optionsRadios1"
            value="option1"
            checked={checked}
            onChange={() => {}}
            onClick={() => this.props.updateSpotToRemove(spotName)}
            disabled={isLocked}
          />
          {spotName}
        </label>
        {isLocked && <span style={{fontStyle: 'italic', marginLeft: '0.25rem'}}>&nbsp;(Locked by Organizer)</span>}
      </div>
    );
  }

}


const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({updateSpotToRemove}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(ReservedSpotRadioButton);



// WEBPACK FOOTER //
// ./src/containers/checkout/ReservedSpotRadioButton.js